import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

export interface ITitleApp {
  marginBottom?: number;
}

const TitleAppText = styled.span<ITitleApp>`
  font-size: 1.2em;
  font-weight: 400;
  color: #4a4b4a;
  margin: 0 0 ${(p) => (p.marginBottom ? `${p.marginBottom}%` : '0px')} 0;
`;

const TitleApp = ({
  children,
  ...props
}: PropsWithChildren<ITitleApp>): JSX.Element => {
  return React.createElement(TitleAppText, props, children);
};

export default TitleApp;
